module.exports = __webpack_public_path__ + "img/ic24Arrowred.d27e240c.svg";